import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { AccountModule } from '@blade-sxp/account/store/account';
import { handleError } from '@blade/common/utils/handle-error';
let default_1 = class default_1 extends Vue {
    number;
    toHide;
    inputMode;
    isShow = false;
    visible1 = false;
    privacyModeShow = false;
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    get showNumber() {
        if (!this.number) {
            return;
        }
        if (this.inputMode === 'EMAIL') {
            const lastIndex = this.number.lastIndexOf('@');
            const dom = this.number.substring(lastIndex + 1);
            const res = this.isShow ? this.number : lastIndex >= 0 ? `*****@${dom}` : '*****';
            return res;
        }
        if (this.number.length < this.toHide) {
            return this.number;
        }
        const slicedStr = this.number.substr(this.number.length - this.toHide);
        const res = this.isShow ? this.number : `${this.getHidden(this.number)}${slicedStr}`;
        return res;
    }
    getHidden(str) {
        const res = str.length < 10 ? str
            .split('')
            .map(item => '*')
            .join('')
            .substr(0, this.number.length - this.toHide) : '**********';
        return res;
    }
    handleShow() {
        if (this.visible1) {
            return;
        }
        const doubleAuth = localStorage.getItem('doubleAuth');
        if (doubleAuth !== 'true' && !this.isShow) {
            this.visible1 = true;
            this.$elprompt(this.$t('text1').toString(), '', {
                confirmButtonText: this.$t('ok').toString(),
                cancelButtonText: this.$t('cancel').toString(),
                inputType: 'password',
                beforeClose: (action, instance, done) => {
                    this.visible1 = false;
                    done();
                }
            }).then(async ({ value }) => {
                console.log('value:', value);
                try {
                    await AccountModule.doubleCheck(value);
                    localStorage.setItem('doubleAuth', 'true');
                    this.isShow = !this.isShow;
                }
                catch (e) {
                    handleError(e);
                }
            }).catch(() => {
            });
        }
        else {
            this.isShow = !this.isShow;
        }
    }
    mounted() {
        if (this.privacyMode === 'true') {
            this.isShow = false;
            localStorage.setItem('doubleAuth', 'true');
        }
        else if (this.privacyMode === 'false') {
            this.isShow = true;
            localStorage.setItem('doubleAuth', 'false');
        }
    }
};
__decorate([
    Prop({ type: String })
], default_1.prototype, "number", void 0);
__decorate([
    Prop({ type: Number, default: 0 })
], default_1.prototype, "toHide", void 0);
__decorate([
    Prop({ type: String })
], default_1.prototype, "inputMode", void 0);
default_1 = __decorate([
    Component({
        name: 'invisible-number',
        i18n: {
            messages: {
                'en-us': {
                    show: 'Show',
                    hide: 'Hide',
                    text1: 'To view data, please enter login password',
                    ok: 'confirm',
                    cancel: 'cancel',
                },
                zh: {
                    show: '显示',
                    hide: '隐藏',
                    text1: '查看原始数据，请输入登录密码二次身份确认',
                    ok: '确认',
                    cancel: '取消'
                },
            },
        },
    })
], default_1);
export default default_1;
